import React, { Component } from 'react';
import clsx from 'clsx';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import './bits.scss';

class AddToggleButton extends Component {
  contents() {
    const iconStyles = { fontSize: '1.2em', marginRight: '3px' };

    if (this.props.checked) {
      return {
        label: 'Added',
        icon: (<CheckCircleOutlineIcon style={iconStyles} />),
      };
    }

    return {
      label: 'Add',
      icon: (<AddCircleOutlineIcon style={iconStyles} />),
    };
  }

  render() {
    const contents = this.contents();

    return (
      <a
        className={clsx({ sgpsAddedToggle: true, 'sgpsAddedToggle--checked': this.props.checked })}
        onClick={() => this.props.onClick(this.props.name)} >
        {contents.icon} {contents.label}
      </a>
    );
  }
}

export default AddToggleButton;
